
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import IndexPage from '@/components/Index.vue'
import MapPage from '@/components/Map.vue'
import VRPage from '@/components/VR.vue'
import EndPage from '@/components/End.vue'

@Options({
  components: {
    IndexPage,
    MapPage,
    VRPage,
    EndPage,
  },
  computed: {
    ...mapState(['userInfo', 'shareData', 'activityData', 'page'])
  },
  mounted() {
    this.$common.pageLoaded()
    let homeShareData = JSON.parse(JSON.stringify(this.shareData))
    homeShareData.link = window.location.href
    this.$common.onshare(homeShareData)
    this.$common.track('load', '进入首页')
  }
})
export default class Index extends Vue {

}
